import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Document, Page } from 'react-pdf/dist/entry.webpack';

import LoadingWrapper from 'components/Common/LoadingWrapper';

// setOptions({
//  workerSrc: 'pdf.bundle.js'
// });

function Repeat(props) {
  const { numTimes, children } = props;

  if (numTimes && children) {
    const items = [];
    for (let i = 1; i <= numTimes; i += 1) {
      items.push(children(i));
    }
    return <div>{items}</div>;
  }

  return <div />;
}

Repeat.propTypes = {
  numTimes: PropTypes.number,
  children: PropTypes.func.isRequired
};

Repeat.defaultProps = {
  numTimes: null
};

class ScrollPdfViewer extends Component {
  static propTypes = {
    file: PropTypes.string
  };

  static defaultProps = {
    file: null
  };

  constructor(props) {
    super(props);

    this.state = {
      numPages: null,
      isLoaded: false
    };
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages, isLoaded: true });
  }

  onDocumentLoadError = ({ error }) => {
    console.error(error.message);
  }

  render() {
    const { file } = this.props;
    const { numPages, isLoaded } = this.state;

    return (
      <div className="pdf-viewer">
        <Document
          file={ file }
          loading={ <LoadingWrapper loaded={ isLoaded } /> }
          noData={ <div className="viewer--nodata"><p>PDF cannot be shown here</p></div> }
          error={ <div className="viewer--error"><p>Sorry, there was a problem displaying the original form.<br />Please &apos;Close original form&apos; and try again.</p></div> }
          onLoadSuccess={ this.onDocumentLoadSuccess }
          onLoadError={ this.onDocumentLoadError }
          className="scroll-pdf-viewer"
          pageNumber={ 1 }
        >
          <Repeat numTimes={ numPages }>
            { index => (<Page
              key={ index }
              pageNumber={ index }
              width={ 1123 }
              noData={ <div /> }
            />) }
          </Repeat>
        </Document>
      </div>
    );
  }
}

export default ScrollPdfViewer;
